import { useEffect, useState } from "react";
import { TrendingUp, Users, MessageSquare, Mic, Info } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

function Limited({ title, icon: Icon }) {
  return (
    <div className="card-elevated p-5 opacity-80">
      <div className="mb-2 flex items-center gap-2"><Icon className="h-4.5 w-4.5 text-slate-500" /><h3 className="font-bold text-white">{title}</h3></div>
      <div className="flex items-center gap-2 rounded-lg border border-[#FEE75C]/20 bg-[#FEE75C]/10 px-3 py-2 text-xs text-[#FEE75C]">
        <Info className="h-4 w-4" /> Richiede raccolta dati dal bot (non ancora attiva). I modelli DB sono predisposti per registrarli nel tempo.
      </div>
    </div>
  );
}

export default function Statistics() {
  const [hist, setHist] = useState(null);
  const [ov, setOv] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.statsHistory().then(setHist).catch((e) => setErr(apiError(e)));
    api.overview().then(setOv).catch(() => {});
  }, []);

  if (err) return <div className="rounded-xl border border-[#F23F43]/30 bg-[#F23F43]/10 px-4 py-3 text-sm text-[#F23F43]">{err}</div>;
  if (!hist || !ov) return <div className="grid gap-5 md:grid-cols-2">{[0,1,2,3].map(i=><Skeleton key={i} className="h-48 rounded-xl bg-white/5" />)}</div>;

  const snaps = hist.snapshots || [];
  const maxM = Math.max(1, ...snaps.map((s) => s.members || 0));
  const first = snaps[0], last = snaps[snaps.length - 1];
  const growth = first && last ? (last.members - first.members) : 0;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-extrabold tracking-tight text-white sm:text-3xl">Statistiche</h1>
        <p className="text-sm text-slate-400">{snaps.length} rilevazioni salvate · ogni sincronizzazione aggiunge un punto</p>
      </div>

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        <div className="card-elevated p-5">
          <div className="mb-4 flex items-center gap-2"><TrendingUp className="h-5 w-5 text-[#23A55A]" /><h3 className="font-bold text-white">Andamento membri</h3><span className="ml-auto font-mono text-sm text-[#23A55A]">{growth >= 0 ? "+" : ""}{growth}</span></div>
          {snaps.length < 2 ? (
            <p className="rounded-lg border border-dashed border-white/10 p-6 text-center text-sm text-slate-500">Servono almeno 2 sincronizzazioni per vedere l'andamento. Premi «Sincronizza Server» nella Panoramica.</p>
          ) : (
            <div className="flex h-40 items-end gap-1">
              {snaps.slice(-30).map((s, i) => (
                <div key={i} className="group flex-1 rounded-t bg-gradient-to-t from-[#5865F2] to-[#8B5CF6] transition-all hover:opacity-80" style={{ height: `${Math.round(((s.members || 0) / maxM) * 100)}%` }} title={`${s.members} membri · ${new Date(s.at).toLocaleString("it-IT")}`} />
              ))}
            </div>
          )}
        </div>

        <div className="card-elevated p-5">
          <div className="mb-4 flex items-center gap-2"><Users className="h-5 w-5 text-[#5865F2]" /><h3 className="font-bold text-white">Composizione attuale</h3></div>
          {[
            { l: "Utenti reali", v: ov.members.real, c: "#5865F2", t: ov.members.total },
            { l: "Bot", v: ov.members.bots, c: "#8B5CF6", t: ov.members.total },
            { l: "Online", v: ov.members.online, c: "#23A55A", t: ov.members.total },
            { l: "Offline", v: ov.members.offline, c: "#80848E", t: ov.members.total },
          ].map((b) => (
            <div key={b.l} className="mb-3">
              <div className="mb-1 flex justify-between text-sm"><span className="text-slate-400">{b.l}</span><span className="font-mono text-white">{b.v}</span></div>
              <div className="h-2 w-full overflow-hidden rounded-full bg-[#0B0C10]"><div className="h-full rounded-full" style={{ width: `${b.t ? (b.v / b.t) * 100 : 0}%`, background: b.c }} /></div>
            </div>
          ))}
        </div>

        <Limited title="Messaggi (giornalieri/settimanali)" icon={MessageSquare} />
        <Limited title="Attività vocale" icon={Mic} />
      </div>
    </div>
  );
}
